/* FASE K2 — Checkbox opt-in GDPR per auto-creazione account cliente.
 *
 * Default: NON selezionato (opt-in esplicito richiesto dal GDPR).
 * Se selezionato, il backend genererà email + password temporanea al submit.
 */
import { UserPlus } from "lucide-react";

export default function AccountOptInCheckbox({
  value,
  onChange,
  tid = "opt-in-crea-account",
}) {
  return (
    <label
      className="flex items-start gap-3 p-3 rounded-xl border-2 border-slate-200 hover:border-emerald-300 bg-white cursor-pointer transition-all"
      data-testid={`${tid}-label`}
    >
      <input
        type="checkbox"
        checked={!!value}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1 w-5 h-5 accent-[#163321] flex-shrink-0"
        data-testid={tid}
      />
      <span className="text-sm">
        <span className="flex items-center gap-1.5 font-semibold text-[#163321] mb-0.5">
          <UserPlus className="w-4 h-4" />
          Voglio creare un account gratuito nell&apos;Area Cliente
        </span>
        <span className="block text-xs text-slate-600 leading-snug">
          Ti creeremo automaticamente un account per seguire lo stato della
          richiesta, scaricare polizze e ricevere notifiche. La password
          temporanea ti sarà mostrata una sola volta a fine invio.
        </span>
      </span>
    </label>
  );
}
